import { Fields } from '@measured/puck';
import ShowComponent from '../../components/showComponents';

export type showComponentProps = {
  showComponent?: string[];
};

type Props = {
  showComponent?: string[];
};

const showComponent: Fields<Props> = {
  showComponent: {
    type: 'custom',
    render: ({ value, onChange }) => (
      <ShowComponent value={value} onChange={onChange} />
    ),
  },
};

export default showComponent;
